
<template>

	<b-modal :id="id" size="xl" v-on:show="reset" v-on:hidden="reset" title="Отображение атрибутов" v-on:ok="ok" ok-title="Применить" cancel-title="Отменить" cancel-variant="outline-primary-secondary" no-close-on-backdrop>

		<form v-on:submit.stop.prevent="submit">

			<b-form-input class="mb-2" v-on:input="search" placeholder="Поиск"/>
			
			<div class="overflow-auto" style="height:30vh;">
				
				<b-form-checkbox-group :options="attrs_visible" v-model="selected" stacked v-on:change="update"/>

			</div>

			<b-button-group class="mt-2 col-12 text-center">

				<b-button variant="outline-primary" v-on:click="check_all()">Выбрать все</b-button>
				<b-button variant="outline-danger" v-on:click="clear_checked()">Очистить выбранные</b-button>

			</b-button-group>

		</form>

	</b-modal>

</template>

<script>

import { uuid } from "vue-uuid"
import api from "../../../api"

export default
{
	data()
	{
		return {
			
			id : uuid.v1(),

			selected : [],
			always_selected : [],
			attrs : [],
			attrs_visible : []

		}
	},

	methods :
	{
		reset()
		{
			this.selected = []
			this.attrs = []
			this.attrs_visible = []
		},

		update(value)
		{
			this.selected = value
			var attrs_visible = this.attrs_visible

			attrs_visible.forEach(attr => { attr.checked = this.selected.indexOf(attr.value) >= 0 })
			this.sort_current_attrs_visible()
		},

		sort_current_attrs_visible()
		{
			this.attrs_visible = this.attrs_visible.sort(
				( a, b ) =>
				{
					if(a.checked && ! b.checked) return -1
					else if(! a.checked && b.checked) return 1
					else if(a.text > b.text) return 1
					else if(a.text < b.text) return -1

					return 0
				})
		},

		clear_checked()
		{
			this.selected = this.always_selected
		},

		check_all()
		{
			this.selected = []

			this.attrs_visible.forEach(attr => this.selected.push(attr.value))
		},

		execute()
		{
			this.$bvModal.show(this.id)

			this.$parent.attrs.forEach(
				attr =>
				{
					if(attr.label)
					{
						this.attrs.push({ text : attr.label, value : attr.key })

						if(this.$parent.attrs_visible.find(attr_visible => attr_visible.key == attr.key))
							this.selected.push(attr.key)
					}
					else
						this.always_selected.push(attr.key)
				})

			this.attrs = api.sort_objects_array_by_key(this.attrs, "text")
			this.attrs_visible = this.attrs
			this.update(this.selected)
		},

		ok(event)
		{
			event.preventDefault()
			this.submit()
		},

		submit()
		{
			const selected = new Set(this.selected)
			const always_selected = new Set(this.always_selected)

			var attrs_visible = []
			var prepared_attrs_visible = []

			this.$parent.attrs.forEach(
				attr =>
				{
					attr.visible = selected.has(attr.key) || always_selected.has(attr.key)

					if(attr.visible)
						attrs_visible.push(attr)
				})

			this.$parent.attrs_visible.forEach(
				attr =>
				{
					const ind = attrs_visible.findIndex(attr_visible => attr_visible.key == attr.key)

					if(ind >= 0)
					{
						prepared_attrs_visible.push(attr)
						attrs_visible.splice(ind, 1)
					}
				})

			attrs_visible.forEach(attr => prepared_attrs_visible.push(attr))
			this.$parent.attrs_visible = prepared_attrs_visible

			if(this.$parent.attrs_visible.every(attr => attr.label == null))
				this.$parent.attrs_visible_if_no_visible.forEach(
					attr =>
					{
						const ind = this.$parent.attrs.findIndex(elem => elem.key == attr.key)

						this.$parent.attrs[ind].visible = true
						this.$parent.attrs_visible.push(attr)
					})

			this.$nextTick(() => { this.$bvModal.hide(this.id, "modal-prevent-closing") })
		},

		search(value)
		{
			const exp = new RegExp(value, "i")

			this.attrs_visible = this.attrs.filter(elem => elem.text.match(exp))
		},
	}
}

</script>

